import * as React from 'react';

import classNames from 'classnames';

import * as styles from './Section.css';

interface ISectionProps extends React.PropsWithChildren {
  padding?: boolean;
  dataMark?: string;
  className?: string;
}

export const Section: React.FC<ISectionProps> = props => {
  const { dataMark, children, className, padding = true } = props;

  return (
    <section
      data-mark={dataMark}
      className={classNames(styles['container'], padding && styles['container--padding'], className)}
    >
      {children}
    </section>
  );
};
